import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { ALBUMS } from "../data/albums";
import type { SelectionMap } from "../types";

interface ReviewScreenProps {
  selections: SelectionMap;
  onEdit(index: number): void;
  onConfirm(): void;
  onBack(): void;
}

export function ReviewScreen({ selections, onEdit, onConfirm, onBack }: ReviewScreenProps) {
  return (
    <EditorialShell className="review-page-shell">
      <section className="review-page page-enter">
        <div className="review-heading">
          <h1>你的九首歌</h1>
          <p>这是你从九张专辑里选出的九首。</p>
        </div>
        <p className="review-lead">再看一遍。轻触任意曲目即可回到对应专辑修改；确认后，所有计算都只在本地完成。</p>
        <ol className="review-list">
          {ALBUMS.map((album, index) => (
            <li key={album.name} className={`review-tone-${index % 3}`}>
              <button onClick={() => onEdit(index)} aria-label={`修改 ${album.name} 的选择`}>
                <span className="review-index">{String(index + 1).padStart(2, "0")}</span>
                <span className="review-cover"><img src={album.cover} alt="" /><b>{album.year}</b></span>
                <span className="review-track"><strong>{selections[album.name]}</strong><small>{album.name}</small></span>
                <span className="review-edit">编辑</span>
              </button>
            </li>
          ))}
        </ol>
        <div className="flow-actions">
          <Action tone="secondary" onClick={onBack}>重新选择</Action>
          <Action onClick={onConfirm}>生成结果</Action>
        </div>
      </section>
    </EditorialShell>
  );
}
